/** Spacing ร่วมสำหรับ Card ที่มี Header + Content บน Studio dashboard */
export const dashboardSectionCardClassName = "gap-0 py-0";
export const dashboardSectionCardHeaderClassName =
  "space-y-1 border-b px-6 py-4";
export const dashboardSectionCardContentClassName = "px-6 py-4";

/** Stat card — มีแค่ content ไม่มี header */
export const dashboardStatCardClassName = "py-0";
export const dashboardStatCardContentClassName =
  "flex items-start justify-between gap-4 px-6 py-5";

/** Layout ร่วมของหน้า dashboard */
export const dashboardPageStackClassName = "flex flex-col gap-8";
export const dashboardKpiGridClassName =
  "grid grid-cols-2 items-stretch gap-4 md:grid-cols-3 xl:grid-cols-5";
export const dashboardKpiGridWideClassName =
  "grid grid-cols-2 items-stretch gap-4 lg:grid-cols-4";
export const dashboardBentoGridClassName =
  "grid grid-cols-1 gap-6 lg:grid-cols-12 lg:items-stretch";
export const dashboardQueueGridClassName =
  "grid grid-cols-1 gap-6 lg:grid-cols-2 lg:items-stretch";
export const dashboardSectionCardFillClassName =
  "flex h-full flex-col";
export const dashboardQuickActionsGridClassName =
  "grid grid-cols-2 gap-2 sm:grid-cols-3 lg:grid-cols-5";
